<div class="chatcontainer flex-grid">
  <section
  *ngIf="!isMobileScreen"
  [ngClass]="isSidebarCollapsed ? 'sidebarCollapsed' : ''"
  class="col sidebar  p-0 ">
      <app-chat-sidebar
          #appChatSidebar
          [isCollapsed]="isSidebarCollapsed"
          (toggleSidebar)="toggleSidebar()"
      ></app-chat-sidebar>
  </section>
  <section class="col main p-0" >
      <app-chat-main
          #appChatMain
      ></app-chat-main>
  </section>
</div>

